export const getStartAdornment = (value: any, multiple?: boolean) => {
    if (multiple && Array.isArray(value)) return <>{value.length ? `+${value.length}` : ''}</>
    else return undefined;
}